import React from 'react';
import { assets, BRAND } from '../../assets/branding';
import { ScanLine, Ruler } from 'lucide-react';

// Left brand-experience panel for the desktop login: a premium "visual
// intelligence" scene — construction photo + AI scanning grid, detection
// bounding boxes and a sweeping scan line — layered over the brand artwork.
export const VisualIntelligenceHero = () => {
  return (
    <div className="relative h-full w-full overflow-hidden bg-secondary" data-testid="login-brand-panel">
      {/* Base construction imagery */}
      <img
        src={assets.loginHero}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover object-center opacity-60 mix-blend-luminosity"
      />
      {/* Navy wash */}
      <div className="absolute inset-0 bg-gradient-to-br from-secondary/90 via-secondary/70 to-secondary/40" />
      {/* Blueprint grid */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(47,155,255,0.10)_1px,transparent_1px),linear-gradient(90deg,rgba(47,155,255,0.10)_1px,transparent_1px)] bg-[size:40px_40px]" />

      {/* AI detection markers */}
      <div className="absolute top-[22%] left-[18%] w-32 h-44 border border-primary/70 bg-primary/10 rounded-sm">
        <span className="absolute -top-6 left-0 bg-primary/90 backdrop-blur-sm text-[10px] text-white px-2 py-0.5 font-mono tracking-wider rounded-sm">
          Column [99%] · 3.2m
        </span>
      </div>
      <div className="absolute bottom-[26%] right-[16%] w-40 h-24 border border-dashed border-primary/70 bg-primary/5 rounded-sm">
        <span className="absolute -top-6 left-0 bg-primary/90 backdrop-blur-sm text-[10px] text-white px-2 py-0.5 font-mono tracking-wider rounded-sm">
          Slab area · ±0.02m
        </span>
      </div>
      {/* Sweeping scan line */}
      <div className="absolute top-0 left-0 w-full h-0.5 bg-primary shadow-[0_0_15px_rgba(47,155,255,0.8)] animate-[rvxscan_3.5s_ease-in-out_infinite]" />

      {/* Brand content */}
      <div className="relative z-10 h-full flex flex-col justify-between p-10 lg:p-14">
        <div className="bg-white/95 rounded-xl px-5 py-4 shadow-xl shadow-black/30 self-start">
          <img src={assets.logo} alt={`${BRAND.productName} logo`} className="h-16 w-auto object-contain" />
        </div>
        <div className="max-w-md">
          <h2 className="text-3xl lg:text-4xl font-extrabold tracking-tight text-white">
            {BRAND.productName}
          </h2>
          <p className="mt-2 text-lg font-semibold text-primary-foreground/90 flex items-center gap-2">
            <ScanLine className="w-5 h-5 text-[#2f9bff]" /> {BRAND.tagline}
          </p>
          <p className="mt-4 text-sm leading-relaxed text-white/70 flex items-start gap-2">
            <Ruler className="w-4 h-4 mt-0.5 text-[#2f9bff] shrink-0" />
            Transform real-world construction environments into measurable, actionable intelligence using AI-powered vision.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VisualIntelligenceHero;
